/* SWEATORJOY collection grid
   Card carousels, tag filtering, and a quick view that is a real purchase
   interface: variant selection, quantity, and AJAX add to cart. */
(function () {
  'use strict';

  var grid = document.getElementById('grid');
  if (!grid) return;

  /* ---------------- card carousels ---------------- */
  grid.querySelectorAll('.product').forEach(function (card) {
    var strip = card.querySelector('.shots');
    var prev = card.querySelector('.arw.prev');
    var next = card.querySelector('.arw.next');
    var dots = card.querySelectorAll('.dot');
    if (!strip) return;

    function sync() {
      var i = Math.round(strip.scrollLeft / strip.clientWidth);
      dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
    }
    strip.addEventListener('scroll', sync, { passive: true });

    if (next) next.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      strip.scrollBy({ left: strip.clientWidth, behavior: 'smooth' });
    });
    if (prev) prev.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      strip.scrollBy({ left: -strip.clientWidth, behavior: 'smooth' });
    });
  });

  /* ---------------- filters ---------------- */
  var filters = document.getElementById('filters');
  var countEl = document.getElementById('count');
  if (filters) {
    filters.querySelectorAll('.chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        filters.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('on'); });
        chip.classList.add('on');
        var want = chip.dataset.filter;
        var shown = 0;
        grid.querySelectorAll('.product').forEach(function (card) {
          var hit = want === 'all' || (' ' + card.dataset.cat + ' ').indexOf(' ' + want + ' ') > -1;
          card.hidden = !hit;
          if (hit) shown++;
        });
        if (countEl) countEl.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
      });
    });
  }

  /* ---------------- quick view ---------------- */
  var qv = document.getElementById('qv');
  if (!qv) return;

  var shots = document.getElementById('qvShots');
  var dots = document.getElementById('qvDots');
  var optionsEl = document.getElementById('qvOptions');
  var qtyInput = document.getElementById('qvQty');
  var addBtn = document.getElementById('qvAdd');
  var errEl = document.getElementById('qvError');
  var priceEl = document.getElementById('qvPrice');
  var flagEl = document.getElementById('qvFlag');
  var opener = null;
  var P = null;
  var chosen = [];

  function step(dir) { shots.scrollBy({ left: dir * shots.clientWidth, behavior: 'smooth' }); }

  function syncDots() {
    var i = Math.round(shots.scrollLeft / shots.clientWidth);
    dots.querySelectorAll('.dot').forEach(function (d, n) { d.classList.toggle('on', n === i); });
  }

  function findVariant() {
    return P.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    })[0] || null;
  }

  function optionAvailable(idx, value) {
    return P.variants.some(function (v) {
      return v.available && v.options.every(function (o, i) {
        return i === idx ? o === value : o === chosen[i];
      });
    });
  }

  function paint() {
    var v = findVariant();

    optionsEl.querySelectorAll('.size').forEach(function (b) {
      var i = parseInt(b.dataset.optionIndex, 10);
      b.classList.toggle('on', chosen[i] === b.dataset.value);
      b.setAttribute('aria-checked', chosen[i] === b.dataset.value ? 'true' : 'false');
      b.classList.toggle('unavailable', !optionAvailable(i, b.dataset.value));
    });

    if (!v) {
      priceEl.textContent = '';
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      flagEl.textContent = '';
      return;
    }

    priceEl.innerHTML = v.compare_html
      ? v.price_html + ' <s class="price-was">' + v.compare_html + '</s>'
      : v.price_html;
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    flagEl.textContent = v.available ? '' : 'Sold out';
    flagEl.classList.toggle('low', !v.available);

    if (v.image) {
      var idx = P.images.indexOf(v.image);
      if (idx > -1) shots.scrollTo({ left: idx * shots.clientWidth, behavior: 'smooth' });
    }
  }

  function open(card) {
    opener = card;
    var json = card.querySelector('.product-json');
    if (!json) return;
    P = JSON.parse(json.textContent);

    if (errEl) errEl.hidden = true;
    qtyInput.value = 1;

    /* photos */
    shots.innerHTML = '';
    dots.innerHTML = '';
    var srcs = P.images.length ? P.images : [null, null, null];
    var labels = ['Front', 'Back', 'Detail'];
    srcs.forEach(function (src, i) {
      var slide = document.createElement('div');
      slide.className = 'shot';
      slide.innerHTML = src
        ? '<img src="' + src + '" alt="">'
        : '<div class="soon">' + (labels[i] || 'Photo') + '</div>';
      shots.appendChild(slide);

      var d = document.createElement('span');
      d.className = 'dot' + (i === 0 ? ' on' : '');
      dots.appendChild(d);
    });
    shots.scrollLeft = 0;
    var many = srcs.length > 1;
    document.getElementById('qvPrev').style.display = many ? '' : 'none';
    document.getElementById('qvNext').style.display = many ? '' : 'none';
    dots.style.display = many ? '' : 'none';

    document.getElementById('qvName').textContent = P.title;
    document.getElementById('qvDesc').textContent = P.description;
    document.getElementById('qvMore').href = P.url;

    /* options */
    optionsEl.innerHTML = '';
    var first = P.variants.filter(function (v) { return v.available; })[0] || P.variants[0];
    chosen = first ? first.options.slice() : [];

    if (!P.hasOnlyDefaultVariant) {
      P.options.forEach(function (opt, idx) {
        var name = typeof opt === 'string' ? opt : opt.name;
        var values = [];
        P.variants.forEach(function (v) {
          if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
        });

        var label = document.createElement('div');
        label.className = 'sub';
        label.textContent = name;
        optionsEl.appendChild(label);

        var row = document.createElement('div');
        row.className = 'sizes';
        row.setAttribute('role', 'radiogroup');
        row.setAttribute('aria-label', name);
        values.forEach(function (value) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'size';
          b.setAttribute('role', 'radio');
          b.dataset.optionIndex = idx;
          b.dataset.value = value;
          b.textContent = value;
          b.addEventListener('click', function () { chosen[idx] = value; paint(); });
          row.appendChild(b);
        });
        optionsEl.appendChild(row);
      });
    }

    paint();
    qv.hidden = false;
    document.body.style.overflow = 'hidden';
    document.querySelector('.qv-close').focus();
  }

  function close() {
    qv.hidden = true;
    document.body.style.overflow = '';
    if (opener) { opener.focus(); opener = null; }
  }

  grid.querySelectorAll('.product').forEach(function (card) {
    card.setAttribute('tabindex', '0');
    card.setAttribute('role', 'button');
    card.addEventListener('click', function (e) {
      if (e.target.closest('.arw')) return;          /* card's own arrows */
      if (e.target.closest('a')) return;             /* title link goes to the product */
      open(card);
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(card); }
    });
  });

  qv.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.getElementById('qvPrev').addEventListener('click', function () { step(-1); });
  document.getElementById('qvNext').addEventListener('click', function () { step(1); });
  shots.addEventListener('scroll', syncDots, { passive: true });

  document.querySelectorAll('[data-qv-q]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, b.dataset.qvQ === 'inc' ? n + 1 : n - 1);
    });
  });

  addBtn.addEventListener('click', function () {
    var v = findVariant();
    if (!v || !window.SJCart) return;
    errEl.hidden = true;
    addBtn.disabled = true;
    var was = addBtn.textContent;
    addBtn.textContent = 'Adding\u2026';

    window.SJCart.add({ items: [{ id: v.id, quantity: parseInt(qtyInput.value, 10) || 1 }] })
      .then(function () { close(); })
      .catch(function (err) { errEl.textContent = err.message; errEl.hidden = false; })
      .then(function () { addBtn.disabled = false; addBtn.textContent = was; });
  });

  document.addEventListener('keydown', function (e) {
    if (qv.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight') step(1);
    if (e.key === 'ArrowLeft') step(-1);
  });
})();
